export default __webpack_public_path__ + "static/media/safezoneOff.7e091aa0.svg";